import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Tiny circular avatar. If `path` is set, fetches the image as a blob
 * (matches AuthImage behaviour). Otherwise renders the first letter of `name`
 * on a champagne gradient circle. `size` is in pixels.
 */
export default function Avatar({ path, name = "", size = 36, className = "" }) {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (!path) {
      setBlobUrl(null);
      return undefined;
    }
    let cancelled = false;
    let url = null;
    (async () => {
      try {
        const r = await api.get(`/files/${path}`, { responseType: "blob" });
        if (cancelled) return;
        url = URL.createObjectURL(r.data);
        setBlobUrl(url);
      } catch (e) {
        if (!cancelled) setBlobUrl(null);
      }
    })();
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  const initial = (name || "?").trim().charAt(0).toUpperCase() || "?";
  const style = { width: size, height: size, fontSize: Math.max(10, Math.floor(size / 2.4)) };

  if (blobUrl) {
    return (
      <img
        src={blobUrl}
        alt={name}
        style={style}
        className={`rounded-full object-cover border border-white/10 ${className}`}
        data-testid="avatar-img"
      />
    );
  }
  return (
    <div
      style={style}
      className={`rounded-full flex items-center justify-center font-serif text-black bg-gradient-to-br from-[#d4af37] to-[#f3e5ab] border border-[#d4af37]/40 select-none ${className}`}
      data-testid="avatar-initial"
    >
      {initial}
    </div>
  );
}
